export default {
  graphqlUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/graphql'
}



// WEBPACK FOOTER //
// ./src/config.js